import { defineMessages } from 'react-intl';

export const messages: {
	teamsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	teamsLabel: {
		id: 'ptc-directory-ui.top-nav.label',
		defaultMessage: 'Teams app',
		description: 'Label text displayed in the top navigation bar for the Teams application',
	},
});
